import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, INTRO_VIDEOS } from '../constants/actionTypes'

const videosSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const introVideosSelector = createSelector(videosSelector, data => data[INTRO_VIDEOS])
